import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SseNotificationService, SseEvent } from '@shared/services/sse-notification.service';

export interface ChatEvent {
  type: 'inquiry.new' | 'inquiry.new_message' | 'inquiry.closed' | 'presence.typing_start' | 'presence.typing_stop' | 'presence.unread_count_changed';
  data: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class ChatSseService {
  private readonly sse = inject(SseNotificationService);

  private static readonly CHAT_EVENTS = [
    'inquiry.new',
    'inquiry.new_message',
    'inquiry.closed',
    'presence.typing_start',
    'presence.typing_stop',
    'presence.unread_count_changed',
  ];

  get chatEvents$(): Observable<ChatEvent> {
    return this.sse.events$.pipe(
      filter(event => ChatSseService.CHAT_EVENTS.includes(event.type)),
      map(event => event as ChatEvent),
    );
  }

  onNewMessage(): Observable<SseEvent> {
    return this.sse.on('inquiry.new_message');
  }

  onNewThread(): Observable<SseEvent> {
    return this.sse.on('inquiry.new');
  }

  onThreadClosed(): Observable<SseEvent> {
    return this.sse.on('inquiry.closed');
  }

  onTypingStart(): Observable<SseEvent> {
    return this.sse.on('presence.typing_start');
  }

  onTypingStop(): Observable<SseEvent> {
    return this.sse.on('presence.typing_stop');
  }

  onUnreadCountChanged(): Observable<SseEvent> {
    return this.sse.on('presence.unread_count_changed');
  }
}
